// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__O5kmi","input":"checkbox_input__A8cyS","label":"checkbox_label__hcNDr"};